import routeParams from 'helpers/routeParams'
import { sameIdsIn } from 'utils/array'
import { PARTICIPANTS_BULK, PROGRESS_STATES } from 'constants/enums'

const GET_TASKS_REGISTRATION =
  'dofe-bo/registrationTasks/GET_TASKS_REGISTRATION'
const GET_TASKS_REGISTRATION_SUCCESS =
  'dofe-bo/registrationTasks/GET_TASKS_REGISTRATION_SUCCESS'
const GET_TASKS_REGISTRATION_FAIL =
  'dofe-bo/registrationTasks/GET_TASKS_REGISTRATION_FAIL'
const SET_TASKS_REGISTRATION_SELECTED = 'dofe-bo/registrationTasks/SET_TASKS_REGISTRATION_SELECTED'
const TOGGLE_TASKS_REGISTRATION_ALL_SELECTED = 'dofe-bo/registrationTasks/TOGGLE_TASKS_REGISTRATION_ALL_SELECTED'

const REFRESH_TASK_REGISTRATION =
  'dofe-bo/registrationTasks/REFRESH_TASK_REGISTRATION'
const REFRESH_TASK_REGISTRATION_SUCCESS =
  'dofe-bo/registrationTasks/REFRESH_TASK_REGISTRATION_SUCCESS'
const REFRESH_TASK_REGISTRATION_FAIL =
  'dofe-bo/registrationTasks/REFRESH_TASK_REGISTRATION_FAIL'

const EXPORT_TASKS_PARTICIPANTS =
  'dofe-bo/registrationTasks/EXPORT_TASKS_PARTICIPANTS'
const EXPORT_TASKS_PARTICIPANTS_SUCCESS =
  'dofe-bo/registrationTasks/EXPORT_TASKS_PARTICIPANTS_SUCCESS'
const EXPORT_TASKS_PARTICIPANTS_FAIL =
  'dofe-bo/registrationTasks/EXPORT_TASKS_PARTICIPANTS_FAIL'
const SET_SORT = 'dofe-bo/registrationTasks/SET_SORT'
const SET_FILTER = 'dofe-bo/registrationTasks/SET_FILTER'
const SET_REMOVED_FILTER = 'dofe-bo/registrationTasks/SET_REMOVED_FILTER'
const SET_BASE_FILTER = 'dofe-bo/registrationTasks/SET_BASE_FILTER'
const SET_LIMIT = 'dofe-bo/registrationTasks/SET_LIMIT'
const SET_OFFSET = 'dofe-bo/registrationTasks/SET_OFFSET'
const SET_PARAMS = 'dofe-bo/registrationTasks/SET_PARAMS'
const SET_REMOVED_PARAMS = 'dofe-bo/registrationTasks/SET_REMOVED_PARAMS'
const SET_DISABLED_CACHE = 'dofe-bo/registrationTasks/SET_DISABLED_CACHE'
const REMOVE_DETAIL_DATA = 'dofe-bo/registrationTasks/REMOVE_DETAIL_DATA'

const REMOVED_PARTICIPANT_REGISTRATIONS =
  'dofe-bo/participant/REMOVED_PARTICIPANT_REGISTRATIONS'
const REMOVED_PARTICIPANT_REGISTRATIONS_SUCCESS =
  'dofe-bo/participant/REMOVED_PARTICIPANT_REGISTRATIONS_SUCCESS'
const REMOVED_PARTICIPANT_REGISTRATIONS_FAIL =
  'dofe-bo/participant/REMOVED_PARTICIPANT_REGISTRATIONS_FAIL'

const RESTORE_REMOVED_PARTICIPANT_REGISTRATIONS =
  'dofe-bo/participant/RESTORE_REMOVED_PARTICIPANT_REGISTRATIONS'
const RESTORE_REMOVED_PARTICIPANT_REGISTRATIONS_SUCCESS =
  'dofe-bo/participant/RESTORE_REMOVED_PARTICIPANT_REGISTRATIONS_SUCCESS'
const RESTORE_REMOVED_PARTICIPANT_REGISTRATIONS_FAIL =
  'dofe-bo/participant/RESTORE_REMOVED_PARTICIPANT_REGISTRATIONS_FAIL'

const BULK_TASK_REGISTRATION_RESET = 'dofe-bo/bulkTasks/BULK_TASK_REGISTRATION_RESET'
const BULK_TASK_REGISTRATION = 'dofe-bo/bulkTasks/BULK_TASK_REGISTRATION'
const BULK_TASK_REGISTRATION_SUCCESS = 'dofe-bo/bulkTasks/BULK_TASK_REGISTRATION_SUCCESS'
const BULK_TASK_REGISTRATION_FAIL = 'dofe-bo/bulkTasks/BULK_TASK_REGISTRATION_FAIL'


const initialState = {
  list: [],
  listRemoved: [],
  detail: {},
  sort: '',
  offset: 0,
  limit: 20,
  pages: 1,
  count: null,
  filter: '',
  loading: false,
  loaded: false,
  selectedIds: [],
  removedRegistrations: {
    loading: false,
    loaded: false,
    list: [],
    sort: '',
    offset: 0,
    limit: 20,
    pages: 1,
    count: null,
    filter: ''
  },
  bulkApprove: {
    loading: false,
    loaded: false
  }
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_TASKS_REGISTRATION:
      return {
        ...state,
        loading: action.enableLoading
      }
    case GET_TASKS_REGISTRATION_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.result || [],
        count: action.headers['x-total-count'],
        pages: Math.ceil(
          Number(action.headers['x-total-count']) / state.limit
        ) || state.pages
      }
    case GET_TASKS_REGISTRATION_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case REFRESH_TASK_REGISTRATION:
      return {
        ...state,
        loading: action.enableLoading
      }
    case REFRESH_TASK_REGISTRATION_SUCCESS:
      const newTask = action.result[0]

      return {
        ...state,
        loading: false,
        loaded: true,
        list: (state.list || [])
          .map(oldTask => (newTask && oldTask.id === newTask.id) ? newTask : oldTask)
      }
    case REFRESH_TASK_REGISTRATION_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case SET_TASKS_REGISTRATION_SELECTED:
      return {
        ...state,
        selectedIds: action.selectedIds
      }
    case TOGGLE_TASKS_REGISTRATION_ALL_SELECTED:
      if (sameIdsIn(action.selectedIds, action.selectableIds)) {
        return {
          ...state,
          selectedIds: []
        }
      }

      return {
        ...state,
        selectedIds: [...action.selectableIds]
      }
    case REMOVED_PARTICIPANT_REGISTRATIONS:
      return {
        ...state,
        removedRegistrations: {
          ...state.removedRegistrations,
          loading: action.enableLoading
        }
      }
    case REMOVED_PARTICIPANT_REGISTRATIONS_SUCCESS:
      return {
        ...state,
        removedRegistrations: {
          ...state.removedRegistrations,
          loading: false,
          loaded: true,
          list: action.result || [],
          count: action.headers['x-total-count'],
          pages: Math.ceil(
            Number(action.headers['x-total-count']) /
            state.removedRegistrations.limit
          ) || state.removedRegistrations.pages
        }
      }
    case REMOVED_PARTICIPANT_REGISTRATIONS_FAIL:
      return {
        ...state,
        removedRegistrations: {
          ...state.removedRegistrations,
          loading: false,
          loaded: false,
          error: action.error
        }
      }
    case SET_SORT:
      return Object.assign({}, state, {
        sort: action.sortBy
      })
    case SET_FILTER:
      return Object.assign({}, state, {
        filter: action.filterBy,
        offset: 0
      })
    case SET_REMOVED_FILTER:
      return {
        ...state,
        removedRegistrations: {
          ...state.removedRegistrations,
          filter: action.filterBy,
          offset: 0
        }
      }
    case SET_BASE_FILTER:
      return Object.assign({}, state, {
        baseFilter: action.filterBy
      })
    case SET_LIMIT:
      return Object.assign({}, state, {
        limit: action.limit
      })
    case SET_OFFSET:
      return Object.assign({}, state, {
        offset: action.offset
      })
    case SET_PARAMS:
      return {
        ...state,
        limit: action.options.limit !== undefined
          ? action.options.limit
          : state.limit,
        offset: action.options.offset !== undefined
          ? action.options.offset
          : state.offset,
        filter: action.options.filter !== undefined
          ? action.options.filter
          : state.filter,
        sort: action.options.sort !== undefined
          ? action.options.sort
          : state.sort
      }
    case SET_REMOVED_PARAMS:
      return {
        ...state,
        removedRegistrations: {
          ...state.removedRegistrations,
          limit: action.options.limit !== undefined
            ? action.options.limit
            : state.limit,
          offset: action.options.offset !== undefined
            ? action.options.offset
            : state.offset,
          filter: action.options.filter !== undefined
            ? action.options.filter
            : state.filter,
          sort: action.options.sort !== undefined
            ? action.options.sort
            : state.sort
        }
      }
    case SET_DISABLED_CACHE:
      return Object.assign({}, state, {
        loaded: false
      })
    case REMOVE_DETAIL_DATA:
      return Object.assign({}, state, {
        detail: {}
      })
    case BULK_TASK_REGISTRATION_RESET:
      return {
        ...state,
        bulkApprove: {
          loading: false,
          loaded: false
        }
      }
    case BULK_TASK_REGISTRATION:
      return {
        ...state,
        bulkApprove: {
          ...state.bulkApprove,
          loading: true,
          loaded: false
        }
      }
    case BULK_TASK_REGISTRATION_SUCCESS:
      return {
        ...state,
        bulkApprove: {
          ...state.bulkApprove,
          loading: false,
          loaded: true,
          detail: action.result
        }
      }
    case BULK_TASK_REGISTRATION_FAIL:
      return {
        ...state,
        bulkApprove: {
          ...state.bulkApprove,
          loading: false,
          error: action.error
        }
      }
    default:
      return state
  }
}

export function getTasksParticipantRegistration(
  params,
  baseFilter,
  { enableLoading = true } = {}
) {
  return {
    types: [
      GET_TASKS_REGISTRATION,
      GET_TASKS_REGISTRATION_SUCCESS,
      GET_TASKS_REGISTRATION_FAIL
    ],
    promise: client =>
      client.get(
        `api/tasks/award-registration-approval?with=LABELS,PARTICIPANT_PERSON,AWARD,AWARD_PAYMENT,AWARD_REGISTRATION,ORGANIZATION${routeParams(params, baseFilter)}`
      ),
    enableLoading
  }
}

export function refreshTaskParticipantRegistration(taskId, { enableLoading = true } = {}) {
  const filter = `id=${taskId}`

  return {
    types: [
      REFRESH_TASK_REGISTRATION,
      REFRESH_TASK_REGISTRATION_SUCCESS,
      REFRESH_TASK_REGISTRATION_FAIL
    ],
    promise: client =>
      client.get(
        `api/tasks/award-registration-approval?with=LABELS,PARTICIPANT_PERSON,AWARD,AWARD_PAYMENT,AWARD_REGISTRATION,ORGANIZATION&filter=${filter}`
      ),
    enableLoading
  }
}

export function setTasksRegistrationSelected(selectedIds) {
  return {
    type: SET_TASKS_REGISTRATION_SELECTED,
    selectedIds
  }
}

export function toggleTasksRegistrationAllSelected(selectedIds, selectableIds) {
  return {
    type: TOGGLE_TASKS_REGISTRATION_ALL_SELECTED,
    selectedIds,
    selectableIds
  }
}

export function exportTasksRegistrationParticipants(params = {}, baseFilter) {
  return {
    types: [
      EXPORT_TASKS_PARTICIPANTS,
      EXPORT_TASKS_PARTICIPANTS_SUCCESS,
      EXPORT_TASKS_PARTICIPANTS_FAIL
    ],
    promise: client =>
      client.get(
        `api/tasks/award-registration-approval?with=LABELS,PARTICIPANT_PERSON,AWARD,AWARD_PAYMENT,AWARD_REGISTRATION,ORGANIZATION${routeParams({ filter: params.filter }, baseFilter)}`
      )
  }
}

export function getRemovedParticipantRegistrations(
  params,
  baseFilter,
  { enableLoading = true } = {}
) {
  return {
    types: [
      REMOVED_PARTICIPANT_REGISTRATIONS,
      REMOVED_PARTICIPANT_REGISTRATIONS_SUCCESS,
      REMOVED_PARTICIPANT_REGISTRATIONS_FAIL
    ],
    promise: client =>
      client.get(`api/participant-registrations/deletions?${baseFilter}`),
    enableLoading
  }
}

export function restoreRemovedRegistration(participantId, registrationId) {
  return {
    types: [
      RESTORE_REMOVED_PARTICIPANT_REGISTRATIONS,
      RESTORE_REMOVED_PARTICIPANT_REGISTRATIONS_SUCCESS,
      RESTORE_REMOVED_PARTICIPANT_REGISTRATIONS_FAIL
    ],
    promise: client =>
      client.post(
        `api/participants/${participantId}/participant-registrations/${registrationId}/undeletion`
      )
  }
}

export function setRegistrationTasksSort(sortBy) {
  return {
    type: SET_SORT,
    sortBy
  }
}

export function setRegistrationTasksFilter(filterBy) {
  return {
    type: SET_FILTER,
    filterBy
  }
}

export function setRemovedRegistrationTasksFilter(filterBy) {
  return {
    type: SET_REMOVED_FILTER,
    filterBy
  }
}

export function setRegistrationTasksBaseFilter(filterBy) {
  return {
    type: SET_BASE_FILTER,
    filterBy
  }
}

export function setRegistrationTasksLimit(limit) {
  return {
    type: SET_LIMIT,
    limit
  }
}

export function setRegistrationTasksOffset(offset) {
  return {
    type: SET_OFFSET,
    offset
  }
}

export function setRegistrationTasksParams(options) {
  return {
    type: SET_PARAMS,
    options
  }
}

export function setRemovedRegistrationTasksParams(options) {
  return {
    type: SET_REMOVED_PARAMS,
    options
  }
}

export function removeRegistrationTasksDetailData() {
  return {
    type: REMOVE_DETAIL_DATA
  }
}

export function removeRegistrationTasksCache() {
  return {
    type: SET_DISABLED_CACHE
  }
}

export function bulkApproveReset() {
  return {
    type: BULK_TASK_REGISTRATION_RESET
  }
}

export function bulkApprove(awardIds, bulkType) {
  const types = [
    BULK_TASK_REGISTRATION,
    BULK_TASK_REGISTRATION_SUCCESS,
    BULK_TASK_REGISTRATION_FAIL
  ]

  switch (bulkType) {
    case PROGRESS_STATES.awardRegApproval.id:

      return {
        types,
        promise: client =>
          client.post(
            'api/awards/registration-approval/bulk',
            {
              data: {
                awardIds
              }
            }
          )
      }

    case PARTICIPANTS_BULK.resendParentalConsent.id:
      return {
        types,
        promise: client =>
          client.post(
            'api/awards/resend-parental-consent-link/bulk',
            {
              data: {
                awardIds
              }
            }
          )
      }

    case PARTICIPANTS_BULK.resendConfirmationEmail.id:
      return {
        types,
        promise: client =>
            client.post(
                'api/awards/resend-confirmation-email/bulk',
                {
                  data: {
                    awardIds
                  }
                }
            )
      }

    case PARTICIPANTS_BULK.changeParentalConsent.id:
      return {
        types,
        promise: client =>
            client.post(
                'api/awards/change-parental-consent/bulk',
                {
                  data: {
                    awardIds
                  }
                }
            )
      }

    default:
      throw new Error(`${bulkType} not implemented`)
  }
}
